<template>
    <div class="table_delete_button" >
        <div class="icon_delete" @click="confirmVisible = true">
            <iconDelete  />
        </div>

        <deleteConfirmBox class="delete_confirm_box" :pose="confirmVisible ? 'visible' : 'hidden'">
            <div class="delete_confirm_text">
                <div>{{ $t('components.tableDeleteButton.areYouSure') }}</div>
                <div>{{ $t('components.tableDeleteButton.irreversibleAction') }}</div>
            </div>
            <div class="delete_confirm_button">
                <span class="button is-danger" @click="confirmClicked">{{ $t('components.tableDeleteButton.confirm') }}</span>
                <span class="button is-inverse" @click="confirmVisible = false">{{ $t('components.tableDeleteButton.cancel') }}</span>
            </div>
        </deleteConfirmBox>

    </div>
</template>

<script>
import posed from 'vue-pose';

export default {
    name: 'TableDeleteButton',
    components: {
        deleteConfirmBox: posed.div({
            visible: {
                opacity: 1,
                width: 'auto',
                transition: { duration: 250, ease: 'easeInOut' }
            },
            hidden: {
                opacity: 0,
                width: 0,
                transition: { duration: 250, ease: 'easeInOut' }
            }
        })
    },
    data(){
        return {
            confirmVisible: false
        }
    },
    computed: {},
    methods: {
        confirmClicked(){
            this.confirmVisible = false
            this.$emit("confirmClicked")
        }
    }
}
</script>

<style lang="scss">
.table_delete_button{
    position: relative;
    svg{
        width: 22px;
        fill: $grey-light;
        transition: .3s all;
    }
    &:hover{
        svg{
            fill: $danger!important;
        }
    }
    .delete_confirm_box{
        position: absolute;
        background: $info;
        color: $white;
        height: 82px;
        top: -24px;
        right: -12px;
        overflow: hidden;
        display: flex;
        align-items: center;
        .delete_confirm_text{
            min-width: 250px;
            padding-left: 12px;
        }
        .delete_confirm_button{
            padding-right: 12px;

            .button{
                width: 100%;
            }
            .is-danger{
                margin-bottom: 2px;
            }
        }
    }
}
</style>